/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useContext, useEffect, useState } from 'react'
import Highlighter from 'react-highlight-words'
import { Link } from 'react-router-dom'

import { ROUTE_TYPE } from '../../Configuration'
import { COMPONENTS_CODE } from '../../assets/ts/data/common-metadata'
import { getBlobStorage } from '../../assets/ts/data/data'
import {
  KnowledgeBase as KnowledgeBaseInterface,
  LIST_NAME as KnowledgeBaselist,
} from '../../assets/ts/data/knowledge-base'
import { formatUTCDateToLocal } from '../../assets/ts/date-and-time/date-and-time'
import { openFile } from '../../assets/ts/files/files'
import { DocumentIconNames, filterBy, getMAJCOMCode, removeTags } from '../../assets/ts/general/general'
import useKnowledgeBase from '../../hooks/use-knowledge-base'
import { MetadataContext } from '../../store/metadata-context-provider'
import { UserContext } from '../../store/user-context-provider'
import {
  ALL_SELECT_LABEL,
  ALL_SELECT_OPTION,
  ALL_SELECT_VALUE,
} from '../../utils/constants/global-constants'
import NO_RESULTS from '../../utils/constants/no-results'
import CustomSelect from '../../utils/controls/custom-select'
import InputSearch from '../../utils/controls/input-search'
import { Dropdown, optionsTypes } from '../../utils/controls/select-options-data'

interface Attachment {
  blobs: any
}
interface DashboardKnowledgeBase {
  Attachments: Attachment[]
  assignComponentCode: number
  categoryCode: number
  content: string
  eKey: string
  extra: string
  id: number
  link: string
  majcomCode: number
  postedDate: string
  section: string
  sectionCode: number
  subcontent: string
  subcontent1: string
  title: string
}
interface KnowledgeBaseprops {
  CategoryOptions: optionsTypes[]
  SectionOptions: optionsTypes[]
  filterCategoryValue?: Dropdown
  filterComponentValue?: Dropdown
  filterMajcomValue?: Dropdown
  filterSectionValue?: Dropdown
  isFilters?: boolean
  searchValue: string
  setCategoryValue: () => void,
  setSearchValue: () => void
  setSectionValue:() => void,
}
const KnowledgeBase = (props: KnowledgeBaseprops) => {
  const {
    CategoryOptions,
    SectionOptions,
    filterCategoryValue,
    filterComponentValue,
    filterMajcomValue,
    filterSectionValue,
    isFilters,
    searchValue,
    setCategoryValue,
    setSearchValue,
    setSectionValue
  } = props
  const { KnowledgeBaseData } = useKnowledgeBase({
    isArchived: false,
  })
  const { userProfile } = useContext(UserContext)

  const { categories, majcoms } = useContext(MetadataContext)
  const [intialKnowledgeBase, setIntialKnowledgeBase] = useState<Array<DashboardKnowledgeBase>>([])
  const [filterKnowledgeBase, setFilteredKnowledgeBase] = useState<Array<DashboardKnowledgeBase>>(
    []
  )
  const [searchKnowledgeBase, setSearchKnowledgeBase] = useState<Array<DashboardKnowledgeBase>>([])

  const [filterValues, setFilterValues] = useState({
    assignedComponent: COMPONENTS_CODE.Regular_Air_Force_LABEL,
    assignedComponentCode: COMPONENTS_CODE.Regular_Air_Force,
    category: ALL_SELECT_LABEL,
    categoryCode: ALL_SELECT_VALUE,
    majcom: ALL_SELECT_LABEL,
    majcomCode: ALL_SELECT_VALUE,
    section: ALL_SELECT_LABEL,
    sectionCode: ALL_SELECT_VALUE,
  })
  const [filterCategoryOptions, setFilterCategoryOptions] = useState<Array<optionsTypes>>([])
  useEffect(() => {
    if(searchValue === '') {
      onSearchChange({ target: { value: '' } })
    }
  },[searchValue])

  useEffect(() => {
    if (!isFilters) {
      const newKnowledgeBase = intialKnowledgeBase?.filter(
        ({ CategoryCodes, SectionCodes, assignComponentCode, majcomCode }) => {
          return (
            filterBy(assignComponentCode, filterComponentValue?.value as number) &&
            filterBy(majcomCode, filterMajcomValue?.value as number) &&
            filterBy(SectionCodes.length > 0 ? SectionCodes : -1, 
              filterSectionValue?.value as number) &&
            filterBy(CategoryCodes.length > 0 ? CategoryCodes : -1, 
              filterCategoryValue?.value as number)
          )
        }
      )
      setFilterValues((prev) => ({
        ...prev,
        assignedComponent: filterComponentValue ? filterComponentValue.label : ALL_SELECT_LABEL,
        assignedComponentCode: filterComponentValue
          ? (filterComponentValue.value as number)
          : ALL_SELECT_VALUE,
        category: filterCategoryValue ? filterCategoryValue.label : ALL_SELECT_LABEL,
        categoryCode: filterCategoryValue
          ? (filterCategoryValue.value as number)
          : ALL_SELECT_VALUE,
        majcom: filterMajcomValue ? filterMajcomValue.label : ALL_SELECT_LABEL,
        majcomCode: filterMajcomValue ? (filterMajcomValue.value as number) : ALL_SELECT_VALUE,
        section: filterSectionValue ? filterSectionValue.label : ALL_SELECT_LABEL,
        sectionCode: filterSectionValue ? (filterSectionValue.value as number) : ALL_SELECT_VALUE,
      }))
      setFilteredKnowledgeBase(newKnowledgeBase)
      setSearchKnowledgeBase(newKnowledgeBase)
    }
  }, [
    intialKnowledgeBase,
    filterSectionValue?.value,
    filterMajcomValue?.value,
    filterCategoryValue?.value,
    filterComponentValue?.value,
  ])

  useEffect(() => {
    setFilterCategoryOptions(CategoryOptions)
  }, [CategoryOptions])

  function codesNullHandler(code: number) {
    return code ? code : -1
  }

  useEffect(() => {
    async function getKnowledgeBaseData() {
      if (KnowledgeBaseData.length > 0) {
        await getBlobStorage(KnowledgeBaselist, KnowledgeBaseData).then((data) => {
          const homeKnowledgeBase: DashboardKnowledgeBase[] = data?.map((item, index) => ({
            Attachments: item.Attachments,
            CategoryCodes: item.CategoryCodes,
            SectionCodes: item.SectionCodes,
            assignComponentCode: codesNullHandler(item.AssignedComponentCode),
            content: item.Description,
            eKey: item.eKey,
            extra: '',
            id: index,
            link: '/knowledgebase',
            majcomCode: codesNullHandler(item.ServicingMAJCOMCode),
            postedDate: formatUTCDateToLocal(item.ItemCreated),
            section: item.Section.join(', '),
            subcontent: `Posted Date: ${formatUTCDateToLocal(item.ItemCreated)}  |  Section : ${
              item.Section
            } `,
            subcontent1: '',
            title: item.Title,
          }))
          if (isFilters) {
            const componentCode = userProfile[0].AssignedComponentCode
            const servicingMAJCOMCode = getMAJCOMCode(userProfile[0].ServicingMAJCOM, majcoms)
            const newAnnouncements = homeKnowledgeBase?.filter(
              ({ assignComponentCode, majcomCode }) => {
                return (
                  filterBy(assignComponentCode, componentCode) &&
                  filterBy(majcomCode, servicingMAJCOMCode)
                )
              }
            )
            setFilterValues((prev) => ({
              ...prev,
              assignedComponentCode: componentCode,
              majcomCode: servicingMAJCOMCode,
            }))
            setIntialKnowledgeBase(newAnnouncements)
            setFilteredKnowledgeBase(newAnnouncements)
            setSearchKnowledgeBase(newAnnouncements)
          } else {
            setIntialKnowledgeBase(homeKnowledgeBase)
            setFilteredKnowledgeBase(homeKnowledgeBase)
            setSearchKnowledgeBase(homeKnowledgeBase)
          }
        })
      }
    }
    getKnowledgeBaseData()
  }, [KnowledgeBaseData])

  const onChangeSection = (e: { label: string; value: number }) => {
    setSearchValue('')
    const options: optionsTypes[] =
      e.value === ALL_SELECT_VALUE
        ? CategoryOptions
        : categories
            .filter(({ ParentSectionCode }) => ParentSectionCode === e.value)
            .map(({ Label, Value }) => ({ label: Label, value: Value }))
    if (options.length > 0 && e.value !== ALL_SELECT_VALUE) {
      options.unshift(ALL_SELECT_OPTION)
    }
    setFilterCategoryOptions(options)
    setSectionValue({ label: e.label, vaue: e.value })
    setCategoryValue(ALL_SELECT_OPTION)
    const newKnowledgeBase = intialKnowledgeBase?.filter(({ sectionCode }) => {
      return filterBy(sectionCode, e.value)
    })
    setFilteredKnowledgeBase(newKnowledgeBase)
    setSearchKnowledgeBase(newKnowledgeBase)
    setFilterValues((prev) => ({
      ...prev,
      category: ALL_SELECT_LABEL,
      categoryCode: ALL_SELECT_VALUE,
      section: e.label,
      sectionCode: e.value,
    }))
  }

  const onChangeCategory = (e: { label: string; value: number }) => {
    setSearchValue('')
    setCategoryValue({ label: e.label, vaue: e.value })
    const newKnowledgeBase = intialKnowledgeBase?.filter(({ categoryCode, sectionCode }) => {
      return filterBy(sectionCode, filterValues.sectionCode) && filterBy(categoryCode, e.value)
    })

    setFilteredKnowledgeBase(newKnowledgeBase)
    setSearchKnowledgeBase(newKnowledgeBase)
    setFilterValues((prev) => ({
      ...prev,
      category: e.label,
      categoryCode: e.value,
    }))
  }
  function onSearchChange(e: { target: { value: string } }) {
    setSearchValue(e.target.value)
    const filtered = filterKnowledgeBase?.filter((data: DashboardKnowledgeBase) => {
      const title = data?.title || ''
      const descriptionWithoutHTML = removeTags(data?.content) || ''
      const Attachments: string[] =
        data?.Attachments[0]?.blobs?.flatMap((blob) => blob?.fileName) || []
      const sections = data?.section
      const postedDate = data?.postedDate
      const queryLowerCase = e.target.value.toLowerCase()
      return (
        title?.toLowerCase().includes(queryLowerCase) ||
        sections?.toLowerCase().includes(queryLowerCase) ||
        postedDate?.toLowerCase().includes(queryLowerCase) ||
        Attachments?.some((filename) => filename.toLowerCase().includes(queryLowerCase)) ||
        descriptionWithoutHTML?.toLowerCase().includes(queryLowerCase)
      )
    })
    setSearchKnowledgeBase(filtered)
  }

  return (
    <>
      <div className='card-header pb-0 d-flex justify-content-between align-items-center border-bottom2 flex-wrap'>
        <div className='d-flex mb-1 title-border align-items-center'>
          <h2
            aria-label='Knowledge Base'
            className='poppins-bold font-14 d-flex align-items-center title-color20'
            tabIndex={0}
          >
            <span className='icon-knowledge-graph font-18'></span> Knowledge Base
          </h2>
        </div>
        <div className='d-flex align-items-center ms-auto'>
          {isFilters && (
            <div className='ms-auto d-flex align-items-center mb-2 flex-wrap'>
              <div className='mx-1'>
                <CustomSelect
                  className='form-sm w-100 max-w-sm-80 min-w-sm-80  sourcesanspro font-13 customselect'
                  formClassName='form-horizontal dash poppins-semibold font-11'
                  id='Section'
                  label='Section'
                  name='Section'
                  onChange={onChangeSection}
                  options={SectionOptions}
                  value={filterValues.sectionCode}
                />
              </div>
              <div className='mx-1'>
                <CustomSelect
                  className='form-sm w-100 max-w-sm-80 min-w-sm-80  sourcesanspro font-13 customselect'
                  formClassName='form-horizontal dash poppins-semibold font-11'
                  id='Category'
                  label='Category'
                  name='Category'
                  onChange={onChangeCategory}
                  options={filterCategoryOptions}
                  value={filterValues.categoryCode}
                />
              </div>
            </div>
          )}
          {searchKnowledgeBase.length > 3 && (
            <Link
              className='links-over-underline font-12 links ps-2 ms-auto mb-2'
              state={{
                filterValues: filterValues,
              }}
              title='View All'
              to={`${ROUTE_TYPE}knowledgebase`}
            >
              View All
            </Link>
          )}
        </div>
      </div>

      <div className='d-flex flex-column py-0 card-body'>
        <div className='font-13 pe-1 border-none'>
          <div className='py-2'>
            <InputSearch
              aria-label='Search'
              className='border w-100 border-radius sourcesanspro font-13 form-md'
              icon='icon-search pe-2'
              inputProps={{
                placeholder: 'Search',
                value: searchValue,
              }}
              onChange={(e: any) => onSearchChange(e)}
              searchgroup=' w-100 d-flex align-items-center inputswithicon '
            />
          </div>
          {searchKnowledgeBase.length === 0 ? (
          <div>
          <NO_RESULTS/>
          </div>
          ) : (
            searchKnowledgeBase.slice(0, 3).map((knowledgebase) => (
              <div className='mb-2 pb-1 border-bottom1' key={knowledgebase.title}>
                <p className='m-0'>
                  <Link
                    className='title-color1 font-13 poppins-semibold  lineClamp1 maxfitcontent'
                    state={{
                      filterValues: filterValues,
                      itemKey: knowledgebase.eKey,
                    }}
                    title={knowledgebase.title}
                    to={knowledgebase.link}
                  >
                    <Highlighter
                      highlightClassName='YourHighlightClass'
                      searchWords={[searchValue]}
                      textToHighlight={knowledgebase.title}
                    />
                  </Link>
                </p>
                <p
                  aria-label={knowledgebase.content}
                  className='m-0 py-1 lineClamp3 sourcesanspro font-13 title-color19 maxfitcontent'
                  tabIndex={0}
                >
                  <Highlighter
                    highlightClassName='YourHighlightClass'
                    searchWords={[searchValue]}
                    textToHighlight={removeTags(knowledgebase.content)}
                  />
                </p>
                {knowledgebase?.Attachments &&
                  knowledgebase?.Attachments[0]?.blobs.length > 0 &&
                  knowledgebase?.Attachments[0].blobs.map((blob) => (
                    <div className='attachmentsfiles' key={blob.fileName}>
                      <a
                        className='py-1 d-inline-block max-fitcontent title-color12 sourcesanspro font-13 me-2 links'
                        href='#'
                        key={blob.fileName}
                        onClick={() => openFile(blob, knowledgebase.eKey, KnowledgeBaselist)}
                        tabIndex={0}
                        title={blob.fileName}
                      >
                        <span className='color-primary'>
                          <span className={`${DocumentIconNames(blob.fileName)} pe-2`}></span>
                          <Highlighter
                            highlightClassName='YourHighlightClass'
                            searchWords={[searchValue]}
                            textToHighlight={blob.fileName}
                          />
                        </span>
                      </a>
                    </div>
                  ))}

                <p
                  aria-label={knowledgebase.subcontent}
                  className='m-0 sourcesanspro subtitle-color2 font-13 maxfitcontent'
                  tabIndex={0}
                >
                  <Highlighter
                    highlightClassName='YourHighlightClass'
                    searchWords={[searchValue]}
                    textToHighlight={knowledgebase.subcontent}
                  />
                </p>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  )
}
export default KnowledgeBase
